module.exports = __webpack_public_path__ + "assets/img/mecha-b80f052c.png";